import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const MenuItemContainer = styled.div`
  display: flex;
  padding: 16px 24px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #dee5ec;

  ${({ isSelected }) => {
    if (isSelected) {
      return `
        border-radius: 8px 8px 0 0;
        background: #eff8fc;
      `;
    } else {
      return `
        background: #fff;
      `;
    }
  }}

  &:hover {
    background: ${({ isSelected }) => (isSelected ? "#eff8fc" : "#f5f5f5")};
  }
`;

const RadioButton = styled.input`
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #1998d5;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #424242;
  cursor: pointer;
  flex: 1;
  line-height: 20px;
`;

const MenuItem = ({ label, value, isSelected, onClick, isFirst, isLast }) => {
  const handleClick = () => {
    onClick(value);
  };

  const handleKeyPress = e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(value);
    }
  };

  return (
    <MenuItemContainer
      isSelected={isSelected}
      isFirst={isFirst}
      isLast={isLast}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      role={"radio"}
      tabIndex={0}
      aria-checked={isSelected}
    >
      <RadioButton
        type={"radio"}
        checked={isSelected}
        onChange={handleClick}
        value={value}
        readOnly
      />
      <Label>{label}</Label>
    </MenuItemContainer>
  );
};

MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool
};

export default MenuItem;
